import React from 'react';
import { AlertCircle, XCircle } from 'lucide-react';
export function PainSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-79">
      <div className="max-w-4xl mx-auto space-y-16" data-id="element-80">
        {/* Opening Hook */}
        <div className="space-y-6 text-center md:text-left" data-id="element-81">
          <p className="font-body text-xl md:text-2xl text-gray-800 leading-relaxed font-medium" data-id="element-82">
            Estás cansada de tirar{' '}
            <span className="font-bold text-red-600" data-id="element-83">
              $2,000 o más cada mes
            </span>{' '}
            en una renta que nunca será tuya. Estás cansada de ver cómo tus
            hijos crecen en un apartamento pequeño porque un papel dice que no
            eres "confiable" para un préstamo.
          </p>
          <p className="font-body text-xl md:text-2xl text-gray-800 leading-relaxed font-medium" data-id="element-84">
            Peor aún: ya fuiste al banco y el oficial, sin siquiera mirarte a
            los ojos, te entregó una carta de rechazo porque tu puntaje es
            demasiado bajo o porque apareció una deuda de hospital de hace 3
            años que ni recordabas.
          </p>
        </div>

        <div className="w-24 h-1 bg-brand-gold mx-auto" data-id="element-85"></div>

        {/* The Problem */}
        <div className="bg-brand-cream p-8 md:p-12 rounded-2xl border border-gray-200 shadow-sm" data-id="element-86">
          <div className="flex items-center gap-4 mb-6" data-id="element-87">
            <AlertCircle className="w-10 h-10 text-brand-navy" data-id="element-88" />
            <h3 className="font-heading text-3xl md:text-4xl font-bold text-brand-navy" data-id="element-89">
              El sistema está en tu contra
            </h3>
          </div>
          <div className="space-y-6 font-body text-lg text-gray-700 leading-relaxed" data-id="element-90">
            <p data-id="element-91">
              El sistema de crédito en Estados Unidos no es justo. Está diseñado
              para mantenerte pagando intereses altos y rentas eternas. Los
              burós de crédito (Equifax, Experian y TransUnion) ganan dinero
              cuando tú fallas.
            </p>
            <p data-id="element-92">
              Si intentas usar las "cartas de disputa" que encuentras gratis en
              Google, el sistema las detecta en segundos con Inteligencia
              Artificial y las rechaza automáticamente como "frívolas". El
              resultado es el mismo: sigues estancada, sin casa y con el sueño
              de tu familia en pausa.
            </p>
          </div>
        </div>

        {/* Why what you tried didn't work */}
        <div className="space-y-8" data-id="element-93">
          <h3 className="font-heading text-3xl md:text-4xl font-bold text-center text-brand-navy mb-10" data-id="element-94">
            Por qué lo que ya intentaste NO funcionó:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-95">
            {['Las agencias de reparación de crédito te cobran $100 al mes por años y solo envían cartas genéricas que no funcionan.', 'Las aplicaciones gratuitas como Credit Karma te muestran un puntaje que NO es el que usa el banco hipotecario.', 'Ignorar las deudas solo hace que crezcan como una bola de nieve por los intereses y cargos de cobranza.', 'Esperar 7 años a que las manchas se borren solas es perder el tiempo más valioso de la infancia de tus hijos.'].map((item, index) => <div key={index} className="flex items-start gap-4 p-6 bg-red-50 rounded-xl border border-red-100" data-id="element-96">
                <XCircle className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-97" />
                <p className="font-body text-gray-800" data-id="element-98">{item}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}